import { useGtm } from '@gtm-support/vue-gtm';


export const sendGtmEvent = ({ event, eventParams }: { event: string, eventParams: any }) => {
  const gtm = useGtm();

  gtm?.trackEvent({
    event,
    ...eventParams
  })


}